import { render } from "./Issues.vue?vue&type=template&id=6aab9262&bindings={\"id\":\"props\",\"group\":\"props\",\"hasFilters\":\"options\",\"allFilters\":\"options\",\"searchPlaceholder\":\"options\",\"getIssueHelp\":\"options\",\"fetchData\":\"options\",\"refresh\":\"options\"}"
import script from "./Issues.vue?vue&type=script&lang=js"
export * from "./Issues.vue?vue&type=script&lang=js"
script.render = render

export default script